const EyeInput = ({ className = '', ...props }) => {
  return <input type="text" {...props} className={`input ${className}`} />;
};

export default EyeInput;
